module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "home"
    }
  }, [_c('section', {
    staticClass: "hero"
  }, [_c('div', {
    staticClass: "hero-body"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('h1', {
    staticClass: "title logo"
  }, [_vm._v("Silko")]), _c('h2', {
    staticClass: "subtitle"
  }, [_vm._v(_vm._s(_vm.tokens['hdr_subtitle']))])])])]), (_vm.isConnecting) ? _c('section', {
    staticClass: "connecting"
  }, [_c('div', [_vm._v(_vm._s(_vm.tokens['msg_connecting']))]), _c('loading')], 1) : (!_vm.user) ? _c('section', [_c('login'), _c('p', {
    staticClass: "control extra-tools"
  }), _c('div', {
    staticClass: "has-text-centered"
  }, [_c('button', {
    staticClass: "button is-link",
    on: {
      "click": _vm.register
    }
  }, [_vm._v(_vm._s(_vm.tokens['btn_request_account']))]), _c('button', {
    staticClass: "button is-link",
    on: {
      "click": _vm.remindPassword
    }
  }, [_vm._v(_vm._s(_vm.tokens['btn_forgot_password']))])]), _c('p')], 1) : _c('section', {
    staticClass: "section"
  }, [_c('div', {
    staticClass: "message is-info"
  }, [_c('div', {
    staticClass: "message-header"
  }, [_c('p', [_vm._v(_vm._s(_vm.tokens['hdr_info_title'](_vm.userTitle)))])]), _c('div', {
    staticClass: "message-body is-paddingless"
  }, [_c('div', {
    staticClass: "panel"
  }, [(_vm.isAdmin || _vm.isSchool) ? _c('div', {
    staticClass: "panel-block"
  }, [_vm._v(_vm._s(_vm.tokens['info_adm_1']))]) : _vm._e(), (_vm.isAdmin) ? _c('div', {
    staticClass: "panel-block"
  }, [_vm._v(_vm._s(_vm.tokens['info_adm_2']))]) : _vm._e(), (_vm.isAdmin || _vm.isSchool || _vm.isTeacher) ? _c('div', {
    staticClass: "panel-block"
  }, [_vm._v(_vm._s(_vm.tokens['info_adm_3']))]) : _vm._e(), (_vm.isAdmin) ? _c('div', {
    staticClass: "panel-block"
  }, [_vm._v(_vm._s(_vm.tokens['info_adm_3']))]) : _vm._e(), (_vm.isTeacher) ? _c('div', {
    staticClass: "panel-block"
  }, [_vm._v(_vm._s(_vm.tokens['info_tch_1']))]) : _vm._e(), (_vm.isTeacher) ? _c('div', {
    staticClass: "panel-block"
  }, [_vm._v(_vm._s(_vm.tokens['info_tch_2']))]) : _vm._e(), (_vm.isTeacher) ? _c('div', {
    staticClass: "panel-block"
  }, [_vm._v(_vm._s(_vm.tokens['info_tch_3']))]) : _vm._e(), (_vm.isTeacher) ? _c('div', {
    staticClass: "panel-block"
  }, [_vm._v(_vm._s(_vm.tokens['info_tch_4']))]) : _vm._e(), (_vm.isTeacher) ? _c('div', {
    staticClass: "panel-block"
  }, [_vm._v(_vm._s(_vm.tokens['info_tch_5']))]) : _vm._e(), (_vm.isTeacher) ? _c('div', {
    staticClass: "panel-block"
  }, [_vm._v(_vm._s(_vm.tokens['info_tch_6']))]) : _vm._e(), (_vm.isStudent) ? _c('div', {
    staticClass: "panel-block"
  }, [_vm._v(_vm._s(_vm.tokens['info_std_1']))]) : _vm._e(), (_vm.isStudent) ? _c('div', {
    staticClass: "panel-block"
  }, [_vm._v(_vm._s(_vm.tokens['info_std_2']))]) : _vm._e(), (_vm.isStudent) ? _c('div', {
    staticClass: "panel-block"
  }, [_vm._v(_vm._s(_vm.tokens['info_std_3']))]) : _vm._e()])])])]), (!_vm.user) ? _c('footer', {
    staticClass: "footer"
  }, [_c('div', {
    staticClass: "columns is-32"
  }, [_c('div', {
    staticClass: "column"
  }, [_c('div', [_vm._v("TAUCHI, COMS, " + _vm._s(_vm.tokens['msg_contact_uta']))])]), _c('div', {
    staticClass: "column is-narrow"
  }, [_c('a', {
    staticClass: "manual",
    attrs: {
      "href": "https://uta-gasp.gitbooks.io/silko/"
    }
  }, [_vm._v(_vm._s(_vm.tokens['manual']))])]), _c('div', {
    staticClass: "column"
  }, [_c('div', {
    staticClass: "browser-info"
  }, [_vm._v(_vm._s(_vm.tokens['msg_test_info']))]), _vm._m(0)])])]) : _vm._e(), (_vm.schools) ? _c('modal-container', {
    attrs: {
      "title": _vm.tokens['tit_registration']
    },
    on: {
      "close": _vm.closeSelectionBox
    }
  }, [_c('div', {
    staticClass: "has-text-centered"
  }, [_c('div', [_vm._v(_vm._s(_vm.tokens['msg_contact_info']))]), _c('div', [_vm._v("Oleg Špakov @ " + _vm._s(_vm.tokens['msg_contact_uta']))]), _c('div', [_vm._v("oleg.spakov at uta dot fi")])])]) : _vm._e(), (_vm.isGettingEmail) ? _c('modal-container', {
    attrs: {
      "title": _vm.tokens['tit_pass_reset']
    },
    on: {
      "close": _vm.closeEmailBox,
      "mounted": _vm.passwordResetAppeared
    }
  }, [(!_vm.schoolToRegester) ? _c('div', {
    staticClass: "field"
  }, [_c('p', {
    staticClass: "control"
  }, [_c('span', [_vm._v(_vm._s(_vm.tokens['hdr_password_reset']))])])]) : _vm._e(), _c('div', {
    staticClass: "field"
  }, [_c('p', {
    staticClass: "control has-icons-left has-icons-right"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.email),
      expression: "email"
    }],
    ref: "email",
    staticClass: "input",
    attrs: {
      "type": "email",
      "placeholder": _vm.tokens['email']
    },
    domProps: {
      "value": (_vm.email)
    },
    on: {
      "keyup": function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "enter", 13, $event.key)) { return null; }
        _vm.sendPasswordResetRequest($event)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.email = $event.target.value
      }
    }
  }), _c('span', {
    staticClass: "icon is-small is-left"
  }, [_c('i', {
    staticClass: "fa fa-envelope"
  })]), (!_vm.isEmailValid) ? _c('span', {
    staticClass: "icon is-small is-right"
  }, [_c('i', {
    staticClass: "fa fa-exclamation-triangle"
  })]) : _vm._e()])]), _c('p', {
    staticClass: "control"
  }), _c('div', {
    staticClass: "has-text-centered"
  }, [_c('button', {
    staticClass: "button is-primary",
    on: {
      "click": _vm.sendPasswordResetRequest
    }
  }, [_vm._v(_vm._s(_vm.tokens['btn_send']))])]), _c('p')]) : _vm._e(), _c('temporal-notification', {
    attrs: {
      "type": "success",
      "show": _vm.showSuccess
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.successMessage))])]), _c('temporal-notification', {
    attrs: {
      "type": "danger",
      "show": _vm.showError
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.errorMessage))])]), _c('div', {
    staticClass: "modal",
    class: {
      'is-active': _vm.isStudent && _vm.showWsSecurityError
    },
    attrs: {
      "id": "ws-security-error"
    }
  }, [_c('div', {
    staticClass: "modal-background"
  }), _c('div', {
    staticClass: "modal-content"
  }, [_c('div', {
    staticClass: "notification is-danger"
  }, [_c('h3', {
    staticClass: "title is-3"
  }, [_vm._v(_vm._s(_vm.tokens['ws_err_title']))]), _c('div', {
    staticClass: "subtitle"
  }, [_vm._v(_vm._s(_vm.tokens['ws_err_subtitle']))]), (_vm.isFirefox) ? _c('ul', {
    staticClass: "unblock-ws-instruction"
  }, [_c('li', {
    staticClass: "step"
  }, [_vm._v("- " + _vm._s(_vm.tokens['ws_unblock_1'][0]) + " \""), _c('span', {
    staticClass: "code"
  }, [_vm._v("about:config")]), _vm._v("\" " + _vm._s(_vm.tokens['ws_unblock_1'][1]))]), _c('li', {
    staticClass: "step"
  }, [_vm._v("- " + _vm._s(_vm.tokens['ws_unblock_2'][0]) + " \""), _c('span', {
    staticClass: "code"
  }, [_vm._v("network.websocket.allowInsecureFromHTTPS")]), _vm._v("\" " + _vm._s(_vm.tokens['ws_unblock_2'][1]))]), _c('li', {
    staticClass: "step"
  }, [_vm._v("- " + _vm._s(_vm.tokens['ws_unblock_3'][0]) + " \""), _c('span', {
    staticClass: "code"
  }, [_vm._v("false")]), _vm._v("\", " + _vm._s(_vm.tokens['ws_unblock_3'][1]) + " \""), _c('span', {
    staticClass: "code"
  }, [_vm._v("true")]), _vm._v("\"" + _vm._s(_vm.tokens['ws_unblock_3'][2]))])]) : _c('div', {
    staticClass: "unblock-ws-instruction"
  }, [_vm._v(_vm._s(_vm.tokens['ws_unblock_4']))])])])])], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "is-inline-block"
  }, [_c('div', {
    staticClass: "browser-name chrome"
  }, [_vm._v("Chrome 55+")]), _c('div', {
    staticClass: "browser-name firefox"
  }, [_vm._v("Firefox 47+")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-5b4bf9e5"}!./~/vue-loader/lib/template-compiler/preprocessor.js?raw&engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/tabs/Home.vue
// module id = 425
// module chunks = 0